import { ALERT_VARIANTS } from 'components/TP-UI/TPAlert/constants';

export const MAX_VISIBLE_SNACKBARS = 5;
export const GAP_BETWEEN_SNACKBARS = 8;
export const AUTO_HIDE_VARIANT_RESTRICTIONS = [ALERT_VARIANTS.WARNING, ALERT_VARIANTS.ERROR];
